{"id":"ProductDetail.Gallery.Carousel","prefabs":{"default":{"children":[{"component":"ProductDetail.Gallery.Carousel","options":"options:*"}]}}}